export default __webpack_public_path__ + "static/big-monitor-236b6dcb3bf905aab247f6a6157c8018.png";